<template>
  <div style="margin: 0 5%">
    <h1 style="font-weight: bold;margin-bottom: 0px">预约凭证</h1>
    <vue-qr align="center" :logoSrc="logoImagePath" :text="text" :size="200" :margin="0" :url="text"
            style="height: 200px;width: 200px;"></vue-qr>
    <a-descriptions
      bordered
      :column="{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }"
      size="small"
      align="left"
      :style="{background:'url('+imagePath+')'}"
    >
      <a-descriptions-item label="申请人姓名">
        {{ this.$route.query.fcreater }}
      </a-descriptions-item>
      <a-descriptions-item label="预约类型">
        {{ ftrantype.ftrantname }}
      </a-descriptions-item>
      <a-descriptions-item label="到访日期">
        {{ arrivedate() }}
      </a-descriptions-item>
      <a-descriptions-item label="离开日期">
        {{ leavedate() }}
      </a-descriptions-item>
      <a-descriptions-item label="到访人姓名">
        {{ this.$route.query.fname }}
      </a-descriptions-item>
      <a-descriptions-item label="到访人电话">
        {{ this.$route.query.fphone }}
      </a-descriptions-item>
      <a-descriptions-item label="车牌号">
        {{ this.$route.query.flicenseplate }}
      </a-descriptions-item>
      <a-descriptions-item label="到访事项">
        {{ this.$route.query.faffair }}
      </a-descriptions-item>
      <a-descriptions-item label="是否带货出门">
        {{ this.$route.query.fgoodsout == 1 ? '是' : '否' }}
      </a-descriptions-item>
      <a-descriptions-item label="公司地址">
        {{ this.$route.query.flocation == 1 ? '太仓港经济技术开发区元江路88号' : '上海市嘉定区蕴北公路1755弄9号楼1-4' }}
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
import axios from "axios";

export default {
  name: "qrcode",
  components: {VueQr},
  data() {
    return {
      text: "http://www.tcnanhua.com:5555/ui/qrcodeCheck?fcreater=" + encodeURIComponent(this.$route.query.fcreater) +
        "&ftrantype=" + encodeURIComponent(this.$route.query.ftrantype) +
        "&farrivetime=" + this.$route.query.farrivetime +
        "&fleavetime=" + this.$route.query.fleavetime +
        "&fname=" + encodeURIComponent(this.$route.query.fname) +
        "&fphone=" + this.$route.query.fphone +
        "&flicenseplate=" + encodeURIComponent(this.$route.query.flicenseplate) +
        "&faffair=" + encodeURIComponent(this.$route.query.faffair) +
        "&fgoodsout=" + this.$route.query.fgoodsout +
        "&fchecker=" + encodeURIComponent(this.$route.query.fchecker) +
        "&flocation=" + this.$route.query.flocation,
      logoImagePath: require('../assets/nh.png'),//中间logo的地址
      imagePath: require('../assets/bj7.jpg'),
      ftrantype: '',
    }
  },
  mounted() {
    axios.get("http://www.tcnanhua.com:5555/t-nh-appointmenttype/selectTNhAppointmenttypeByFtrantype?ftrantype=" + this.$route.query.ftrantype)
      .then((res) => {
        this.ftrantype = res.data.data;
      })
  },
  // computed: {
  //   formDate: function () {
  //     let dateUtil = new Date(this.$route.query.fdate / 1);
  //     let month = dateUtil.getMonth() + 1;
  //     return dateUtil.getFullYear() + "年" + month + "月" + dateUtil.getDate() + "日  " + dateUtil.getHours() + ":" + dateUtil.getMinutes() + ":" + dateUtil.getSeconds();
  //   },
  // },
  methods: {
    arrivedate() {
      let date = new Date(this.$route.query.farrivetime / 1);
      let month = date.getMonth() + 1;
      return date.getFullYear() + "年" + month + "月" + date.getDate() + "日  " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
    },
    leavedate() {
      let date = new Date(this.$route.query.fleavetime / 1);
      let month = date.getMonth() + 1;
      return date.getFullYear() + "年" + month + "月" + date.getDate() + "日  " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
    },
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/QRcode.vue